import { isIsolatedAccessor } from './accessors.js';
import type { SparklineGapPolicy } from '../types/sparkline-props.js';

export const shouldDisplayScatterPlot = (gapPolicy: SparklineGapPolicy) => {
  return gapPolicy === 'gap' ? isIsolatedAccessor : () => false;
};
